module.exports = __webpack_public_path__ + "static/img/accessible-basemap-colorbar.bb8a79a.png";